import React, { useState } from 'react';
import SectionListing from "../../newComponents/sectionListing";
import Card from "../../newComponents/card";
import GeneralSection from "../../newComponents/generalSection";
import ImgixFilePreview from '../../newComponents/ImgixFilePreview';
import YoutubeEmbed from '../../newComponents/youtubeEmbed';
import CardVideoPopUp from '../../newComponents/cardVideoPopUp';
import { useQuery } from "@apollo/client";
import { HandleQuery, SslnDocumentsData } from "../../../queries";

function SslnDocuments() {

  const [selectedSslnDocumentType, setSelectedSslnDocumentType] = useState("");
  const [selectedSslnCountry, setSelectedSslnCountry] = useState("");
  const [selectedHivPreventionPillar, setSelectedHivPreventionPillar] = useState("");

  const [shownItems, setShownItems] = useState(6);
    
    const query_state = useQuery(SslnDocuments);
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 

  const sslnCountry = { ghana: "Ghana", nigeria: "Nigeria", uganda: "Uganda", kenya: "Kenya", tanzania: "Tanzania", malawi: "Malawi", zambia: "Zambia", zimbabwe: "Zimbabwe", mozambique: "Mozambique", southAfrica: "South Africa", };
  const sslnDocumentType = { nationalStrategicPlans: "National Strategic Plans (NSPs)", gpcCountryScorecards: "GPC Country Scorecards", guidelines: "Guidelines and Strategies", caseStudies: "Case studies", termsOfReferences: "Terms of References", hivPreventionTools: "HIV Prevention Tools", reports: "Reports", researchPapersAndPublications: "Research Papers and Publications", sslnWebinars: "SSLN Webinars", sslnPsatSummaries: "SSLN PSAT Summaries", costingCostEffectiveness: "Costing & Cost-effectiveness"};
  const hivPreventionPillar = { generalPrevention: "General Prevention", condoms: "Condoms", keyPopulations: "Key Populations",  };

  
  let sslnDocuments = [];

  for(var i = 0; i < data.items.nodes.length; i++) {

    sslnDocuments.push(data.items.nodes[i]);
  }

  sslnDocuments.sort((a, b) => a.title.localeCompare(b.title))

  
  function handleSslnDocumentTypeChange(event) {

    setShownItems(data.items.nodes.length)
    setSelectedSslnDocumentType(event.target.value);
  }

  function handleSslnCountryChange(event) {

    setShownItems(data.items.nodes.length)
    setSelectedSslnCountry(event.target.value);
  } 

  function handleHivPreventionPillarChange(event) {

    setShownItems(data.items.nodes.length)
    setSelectedHivPreventionPillar(event.target.value);
  }

  return (
    <GeneralSection>
      <select className="p-2 mr-2 mb-2" style={{ border: "1px solid #e6e6e6", paddingRight: "1.5rem", }} onChange={handleSslnDocumentTypeChange}>
        <option value="">All document types</option>
        {Object.keys(sslnDocumentType).map(function(key) {
          return(
            <option value={key}>{sslnDocumentType[key]}</option>
          );
        })} 
      </select>
      <select className="p-2 mr-2 mb-2" style={{ border: "1px solid #e6e6e6", paddingRight: "1.5rem", }} onChange={handleSslnCountryChange}>
        <option value="">All countries</option>
        {Object.keys(sslnCountry).map(function(key) {
          return(
            <option value={key}>{sslnCountry[key]}</option>
          );
        })}
      </select>
      <select className="p-2 mr-2 mb-2" style={{ border: "1px solid #e6e6e6", paddingRight: "1.5rem", }} onChange={handleHivPreventionPillarChange}>
        <option value="">All HIV prevention pillars</option>
        {Object.keys(hivPreventionPillar).map(function(key) {
          return(
            <option value={key}>{hivPreventionPillar[key]}</option>
          );
        })}
      </select>
      <SectionListing primaryBackground={true} style={{paddingTop: "0"}}>
        {sslnDocuments.map((item, index) => {

          if(index < shownItems) {

            if ((selectedSslnDocumentType === "" || item.sslnDocumentType === selectedSslnDocumentType) && (selectedSslnCountry === "" || item.sslnCountry === selectedSslnCountry) && (selectedHivPreventionPillar === "" || item.hivPreventionPillar === selectedHivPreventionPillar)) {
              
              if(item.sslnVideoLink && item.sslnVideoLink.url) {

                const id = item.sslnVideoLink.url.substr(item.sslnVideoLink.url.length - 11);
                const placeHolderImage = <div style={{position: "relative", width: "100%", height: "0", paddingBottom: "56.25%"}}>
                  <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt="" height="100%" width="100%" style={{ position: "absolute", width: "100%", height: "100%", left: "0", top: "0", }}/>
                </div>;

                return(
                  <CardVideoPopUp key={`ssln-documents-item-${index}`} image={item.featureImage[0]} title={item.title} readMoreLabel="View video" ar={16/9} placeHolderImage={placeHolderImage} modalTitle={item.title} color={1}>
                    <YoutubeEmbed title={item.title} url={item.sslnVideoLink.url} ar={item.sslnVideoLink.aspectRatio}/>
                  </CardVideoPopUp>
                );

              } else if (item.file.length > 0) return(<Card key={`ssln-documents-item-${index}`} image={item.featureImage[0]} ar={2} title={item.title} subtitle={item.summary} href={item.file[0].url} color={1} readMoreLabel="Download" replacementImage={item.file[0].mimeType === "application/pdf" ? <ImgixFilePreview fileUrl={item.file[0].url} className="mt-2 border-gray-100 border-solid border aspect[1/1]"/> : null }/>);
              else if (item.sslnLink) return(<Card key={`ssln-documents-item-${index}`} image={item.featureImage[0]} ar={2} title={item.title} subtitle={item.summary} href={item.sslnLink} color={1} readMoreLabel="Open link"/>);
              else return <></>;

            } else return <></>;
          } else return <></>;
        })}
      </SectionListing>
      {shownItems < data.items.nodes.length ? 
        <div className="flex justify-center mb-4">
          <button type="button" onClick={() => {setShownItems(data.items.nodes.length)}} className="btn btn--green btn--icon form__btn" style={{backgroundColor: "#4fa699"}}>View all</button>
        </div>
        :
        <></>
      }
    </GeneralSection>
  );
}

export default SslnDocuments;
